<template>
  <div v-if="showTutorial">
    <div class="do-yt fadeIn js-dontCloseSidenav">
      <div class="do-yt__container">
        <div class="do-yt__container-close js-dontCloseSidenav" @click="closeYouTubePopup">
          <span class="icon-cross2 js-dontCloseSidenav"></span>
        </div>
        <div class="do-yt__embed" :class="{'scaleUp': classListTimeout}">
          <youtube ref="youtube"
                   :video-id="videoId"
                   :player-vars="videoVars"
                   @ready="videoReady"
                   @cued="videoCued"
                   @playing="videoPlaying"
                   @ended="videoEnded">
          </youtube>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import eventbus from '../../eventbus'

  export default {
    name: 'do-youtube',
    description: 'Popup that plays youtube-videoes. Tags: Popup, YouTube-API, responsive',
    computed: {
      player () {
        return this.$refs.youtube.player
      },
      showTutorial () {
        return eventbus.isOpenYouTubePopup
      },
      videoId () {
        return eventbus.youTubeVideoId
      }
    },
    watch: {
      showTutorial (val) {
        if (val) {
          setTimeout(() => {
            this.classListTimeout = true
          }, 0)
        }
      }
    },
    data () {
      return {
        videoVars: {
          autoplay: 1,
          modestbranding: 1, // remove youtube logo
          rel: 0 // related videos will come from the same channel as the video that was just played
        },
        classListTimeout: false
      }
    },
    methods: {
      playVideo (youTubeUrl) {
        // this.getVideoId(youTubeUrl)
        setTimeout(() => {
          this.player.playVideo()
        })
      },
      getVideoId (youTubeUrl) {
        this.videoId = this.$youtube.getIdFromUrl(youTubeUrl)
      },
      closeYouTubePopup () {
        eventbus.isOpenYouTubePopup = false
        this.player.stopVideo()
        this.classListTimeout = false
      },
      videoPlaying () {
        console.log('video started')
      },
      videoEnded () {
        this.closeYouTubePopup()
        console.log('video ended')
      },
      videoReady () {
        console.log('video ready')
      },
      videoCued () {
        console.log('video cued')
      }
    }
  }
</script>


<style>
  .do-yt {
    z-index: 9990;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    opacity: 0;
    text-align: center;
    white-space: nowrap;
    background: #0b0b0b;
    background: rgba(0, 0, 0, 0.9);
    outline: none !important;
    transition: opacity 1s ease;
  }

  .do-yt.fadeIn {
    opacity: 1;
  }

  .do-yt__container-close {
    position: absolute;
    z-index: 19998;
    top: -10px;
    right: 10px;
    font-size: 1.75rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 46px;
    height: 46px;
    background: #fff;
    border-radius: 50%;
    box-shadow: 0 30px 60px -12px rgba(50, 50, 93, .25), 0 18px 36px -18px rgba(0, 0, 0, .3);
    overflow: hidden;
    color: #32325d;
    transition: all .15s;
    border: 1px solid #cccccc;
  }

  .do-yt__container-close:hover {
    opacity: 0.9;
    transform: translateY(-2px);
  }

  .do-yt__container {
    width: 100%;
    max-width: 964px;
    z-index: 9992;
    position: relative;
    text-align: left;
    vertical-align: middle;
    margin: 50px auto 0;
    white-space: normal;
    max-height: 100%;
    outline: none !important;
  }

  .do-yt__container:before {
    content: '';
    display: inline-block;
    height: 100%;
    vertical-align: middle;
    margin-right: -0.25em;
  }

  .do-yt__embed {
    transform: scale(0.65);
    position: relative;
    padding-bottom: 56.25%;
    height: 0;
    overflow: hidden;
    max-width: 100%;
    background-color: black;
    transition: transform 0.4s ease;
  }

  .scaleUp.do-yt__embed {
    transform: scale(1);
  }

  .do-yt__embed iframe, .do-yt__embed object, .do-yt__embed embed {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

</style>



// WEBPACK FOOTER //
// DoYouTube.vue?40b8da7a